import React from "react";

export default function DateInputField({
  value,
  onChange,
  placeholder,
  className = "border-[#232633 text-[14px] shadow-[2px_2px_5px_0_rgba(0,_39,_81,_0.25)_inset] bg-transparent",
}) {
  const handleClick = (e) => {
    // This is directly triggered by a user click, so it's allowed
    if (typeof e.target.showPicker === "function") {
      try {
        e.target.showPicker();
      } catch (error) {
        console.warn("showPicker not supported:", error);
      }
    }
  };

  return (
    <input
      type="date"
      className={`w-full p-2 py-1  text-[#242424]  font-normal rounded-[4px] border  outline-none  appearance-none text-center cursor-pointer ${className}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onClick={handleClick} // ✅ Only here
    />
  );
}
